import { Controller } from "stimulus"
export default class extends Controller {
  toggle(e) {
    e.target.closest("form").submit()
  }
}
